export interface IHeaderBidderUploadID {
  key: string;
  text: string;
}

// export const HeaderBidderUploadIDs: IHeaderBidderUploadID[] = [
//     { key: 'hb_samsungssp_new_v1', text: 'Samsung SSP v1' },
//     { key: 'hb_samsungssp_new', text: 'Samsung SSP v2' },
// ];

// Commented out lines are not supported yet
export const HeaderBidderUploadIDs: IHeaderBidderUploadID[] = [
  // { key: 'beachfront', text: 'Beachfront' },
  // { key: 'consumable', text: 'Consumable' },
  { key: 'hb_freewheel', text: 'Freewheel' },
  // { key: 'gumgum', text: 'GumGum' },
  // { key: 'improvedigital', text: 'Improve Digital' },
  { key: 'hb_indexexchange', text: 'Index Exchange' },
  // { key: 'hb_inmobi', text: 'InMobi' },
  { key: 'hb_iponweb', text: 'The MediaGrid' },
  // { key: 'hb_magnite', text: 'Magnite' },
  // { key: 'hb_mobfox', text: 'MobFox' },
  { key: 'hb_nexstar', text: 'VGI CTV' },
  // { key: 'hb_openx', text: 'OpenX' },
  // { key: 'hb_origin', text: 'Origin Media' },
  // { key: 'hb_platformConnection', text: 'Fixed Price Platform Connection' },
  // { key: 'hb_publicaCampaign', text: 'Direct Campaign' },
  // { key: 'pubmatic', text: 'Pubmatic' },
  // { key: 'rubicon', text: 'Rubicon' },
  // { key: 'hb_samsung', text: 'Samsung' },
  { key: 'hb_samsungssp', text: 'Samsung SSP' },
  // { key: 'hb_samsungssptest', text: 'Samsung SSP Test' },
  { key: 'hb_smaato', text: 'Smaato' },
  // { key: 'smartadserver', text: 'Smart Ad Server' },
  { key: 'hb_telaria', text: 'Telaria' },
  // { key: 'hb_triplelift', text: 'TripleLift' },
  { key: 'hb_trustx', text: 'TrustX' },
  // { key: 'hb_rhythmone', text: 'Nexxen CTRL' },
  { key: 'hb_verizon', text: 'Yahoo' },
  { key: 'hb_appnexus', text: 'Xandr' },
  { key: 'hb_publica', text: 'Other (VAST tag)' },
  // { key: 'zedo', text: 'Zedo' },
];
